import { NotebookHeartIcon } from './NotebookHeartIcon';

/**
 * author: Austin Andrews
 * id BA533C71-48B2-4D1D-8069-98F53EC6224B
 * name notebook-heart
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/notebook-heart.svg
 * tags
 */
export const NotebookLoveIcon = NotebookHeartIcon;
export default NotebookLoveIcon